import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import {FidelioConfig} from "crqlar-react-common/dist/models/integrations/fidelio/fidelio.config";
import ImportLogsTable from "../../common/ImportLogsTable";

interface Props {
    configData: UseEntityData<FidelioConfig>
}

const Logs = ({configData}: Props) => (
    <ImportLogsTable
        configId={configData.item.id}
        tableId="system-fidelio-import-logs"
    />
);

export default Logs;
